import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import {
  ClientSelector,
  BuildingSelector,
  PDFReportButton,
  sampleClientData
} from './BuildingComplianceReportComponents';
import { useClient } from '../../../reactQuery/client';
import { useClientBuildings } from '../../../reactQuery/building';
import { useLeadCompliance } from '../../../reactQuery/leadCompliance';

function BuildingComplianceReport({ handleBuildingReport }) {
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedBuilding, setSelectedBuilding] = useState('');
  const [buildings, setBuildings] = useState([]);
  const [pdfData, setPdfData] = useState(null);

  const {responseData: clients, } = useClient({pagination: false,}, "annual-compliance-clients");

  const { isLoading, error, responseData, isError, refetch, totalRecords } =
    useClientBuildings(
      {
        page: 1,
        pageSize: 1,
        clientId: selectedClient,
        pagination: false,
        compliance: `&mailer_program=true`,
      },
      selectedClient
    );

    const currentYear = new Date().getFullYear();
    const prepareQueryFilters = `?page=1&page_size=100&year=${currentYear}&client_id=${selectedClient}&building_id=${selectedBuilding}&pagination=false`;
    const {
      responseData: leadComplianceData,
      refetch: refetchLeadCompliance,
      statusCount,
    } = useLeadCompliance(prepareQueryFilters, "BuildingComplianceReport");

    useEffect(() => {
      if(selectedClient && selectedBuilding){
        refetchLeadCompliance();
      }
    }, [
      selectedClient,
      selectedBuilding,
    ]);

    useEffect(() => {
      refetch();
    }, [selectedClient]);

  const handleClientChange = (event) => {
    const client = event.target.value;
    setSelectedClient(client);
    setSelectedBuilding('');
  };

  useEffect(() => {
    if (responseData) {
      setBuildings(responseData);
    }
  }, [responseData.length]);

  const handleBuildingChange = (event) => {
    setSelectedBuilding(event.target.value);
  };

  useEffect(() => {
    if (selectedClient && selectedBuilding) {
      setPdfData({
        client: clients.find(client => client.client_id === selectedClient),
        building: buildings.find(building => building.building_id === selectedBuilding)
      });
    }
  }, [selectedClient, selectedBuilding]);


  return (
    <Box className="report-card-content">
      <Typography variant="body2" className="report-description">
        Generate a report with a unit-level breakdown of required annual safety
        actions—visual inspections, knob cover installations, window guard
        installations, and repairs—for the selected building.
      </Typography>
      <Box className="report-action report-action-double">
        <ClientSelector
          selectedClient={selectedClient}
          handleClientChange={handleClientChange}
          clients={clients}
        />

        <BuildingSelector
          selectedBuilding={selectedBuilding}
          handleBuildingChange={handleBuildingChange}
          disabled={!selectedClient || isLoading}
          buildings={buildings}
        />

        <PDFReportButton
          pdfData={pdfData}
          statusCount={statusCount}
          leadComplianceData={leadComplianceData}
          disabled={!selectedClient || !selectedBuilding}
        />
      </Box>
    </Box>
  );
}

export default BuildingComplianceReport;